import ContactForm from "./ContactForm";
import { useT } from "../i18n";
import { sectionHeading, sectionSubheading } from "../lib/ui";

export default function ContactSection() {
  const translate = useT();

  return (
    <section
      id="contact"
      className="py-16 sm:py-24"
      aria-labelledby="contact-heading"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 id="contact-heading" className={sectionHeading}>
            {translate("contactSectionTitle")}
          </h2>
          <p className={`${sectionSubheading} mx-auto`}>{translate("contactSectionSubtitle")}</p>
        </div>

        <div className="mx-auto mt-10 max-w-xl">
          <ContactForm source="landing" />
        </div>
      </div>
    </section>
  );
}
